import * as yup from "yup";
import { CantidadSchema } from "./CantidadSchema";
import { PuntoGeograficoSchema } from "./PuntoGeograficoSchema";

export const PozoAguaSubterraneaSchema = yup.object().shape({
  orden: yup.number().required("errors.pozoAguaSubterranea.orden.required"),
  caudalMedio: CantidadSchema.required(
    "errors.pozoAguaSubterranea.caudalMedio.required",
  )
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M3DIA" } }),
  caudalPico: CantidadSchema.required(
    "errors.pozoAguaSubterranea.caudalPico.required",
  )
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M3H" } }),
  ubicacion: PuntoGeograficoSchema.required(
    "errors.pozoAguaSubterranea.ubicacion.required",
  ).default(PuntoGeograficoSchema.cast(undefined, { assert: false })),
  profundidad: CantidadSchema.required(
    "errors.pozoAguaSubterranea.profundidad.required",
  )
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "MBBP" } }),
  caudalimetroFunciona: yup
    .boolean()
    .required("errors.pozoAguaSubterranea.caudalimetroFunciona.required")
    .default(false),
});
